/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// component
import Cropper from 'material/imageupload/components/cropper/cropper';



/* ========== ~~~~~~~~~~ IMAGE UPLOAD : CROPER : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    activeSelection: embedsState.embedManagementState.contentStatus.activeSelection, // background, questionImage, option_0, option_1, option_2, option_3
    selectedEmbedPlacement: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location
  });



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps
)(Cropper);
